import { Paper, styled } from "@mui/material"

const PaddedPaper = styled(Paper)`
  padding: 1em;
`

export default PaddedPaper
